import {
  Document, Page, Text, View, StyleSheet,
  Image as PDFImage,
} from '@react-pdf/renderer';

// -- Helpers --
const fmtData = (d) => {
  if (!d) return '—';
  const [y, m, g] = d.split('-');
  return g + '/' + m + '/' + y;
};

const TIPOLOGIA_LABEL = {
  ristrutturazione: 'Ristrutturazione', elettrico: 'Impianto elettrico',
  idraulico: 'Impianto idraulico', tetto: 'Tetto e coperture',
  nuovo_edificio: 'Nuovo edificio', altro: 'Altro',
};
const STATO_LABEL = {
  nuovo: 'Nuovo', sopralluogo: 'Sopralluogo', in_corso: 'In corso',
  sospeso: 'Sospeso', completato: 'Completato', annullato: 'Annullato',
};
const METEO_LABEL = {
  sole: 'Sole', nuvoloso: 'Nuvoloso', pioggia: 'Pioggia',
  freddo: 'Freddo', vento: 'Vento',
};

const MAX_FOTO_PDF = 20;

// -- Palette --
const GREEN    = '#2EA084';
const MINT     = '#B5D3C5';
const DARK     = '#1a1a2e';
const NAVY     = '#0A1628';
const GRAY     = '#868e96';
const LIGHT    = '#f8f9fa';
const BORDER   = '#e9ecef';
const ORANGE   = '#EF9F27';
const BLUE     = '#378ADD';
const RED      = '#E24B4A';

// Margini standard: 2.5 cm = ~71 pt (NON TOCCARE)
const MARGIN_TOP = 71;
const MARGIN_BOTTOM = 71;

// -- Stili --
const s = StyleSheet.create({
  // Padding Page — garantisce margini su TUTTE le pagine (NON TOCCARE)
  page: {
    fontFamily: 'Helvetica', backgroundColor: '#fff', fontSize: 10, color: DARK,
    paddingTop: MARGIN_TOP, paddingBottom: MARGIN_BOTTOM, paddingLeft: 40, paddingRight: 40,
  },

  // Header fisso — absolute, vive nel margine superiore
  fixedHeader: { position: 'absolute', top: 0, left: 0, right: 0, backgroundColor: '#fff' },
  headerBar: { height: 5, backgroundColor: GREEN },
  // [FIX 1] paddingTop 12→20, paddingBottom 10→18 (+8pt ciascuno)
  logoRow: {
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
    paddingLeft: 40, paddingRight: 40, paddingTop: 20, paddingBottom: 18,
  },
  logoInner: { flexDirection: 'row', alignItems: 'center', gap: 8 },
  logoBox: {
    width: 26, height: 26, borderRadius: 6,
    backgroundColor: MINT, alignItems: 'center', justifyContent: 'center',
    marginRight: 8,
  },
  logoM:    { fontSize: 13, fontFamily: 'Helvetica-BoldOblique', color: '#fff' },
  logoName: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: DARK, letterSpacing: 0.3 },
  logoSub:  { fontSize: 7, color: GRAY, letterSpacing: 1.5, marginTop: 1 },
  headerRight: { alignItems: 'flex-end' },
  headerRightText: { fontSize: 8, color: GRAY, fontStyle: 'italic', textAlign: 'right' },
  headerSep: { height: 1, backgroundColor: BORDER, marginLeft: 40, marginRight: 40 },

  content: { },

  titleSection: { marginBottom: 14, paddingBottom: 12, borderBottomWidth: 1, borderBottomColor: BORDER, borderBottomStyle: 'solid' },
  title: { fontSize: 18, fontFamily: 'Helvetica-Bold', color: DARK, marginBottom: 2 },
  subtitle: { fontSize: 10, color: GRAY, marginBottom: 6 },

  sectionTitle: { fontSize: 8, fontFamily: 'Helvetica-Bold', color: GREEN, textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 8, marginTop: 16 },

  infoGrid: { flexDirection: 'row', flexWrap: 'wrap' },
  infoCell: { width: '50%', marginBottom: 8 },
  infoLabel: { fontSize: 7, color: GRAY, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 2 },
  infoValue: { fontSize: 10, color: DARK },

  kpiRow: { flexDirection: 'row', gap: 8, marginBottom: 4 },
  kpiBox: { flex: 1, padding: 10, backgroundColor: LIGHT, borderRadius: 6, alignItems: 'center' },
  kpiLabel: { fontSize: 7, color: GRAY, textTransform: 'uppercase', letterSpacing: 0.8, marginBottom: 3 },
  kpiValue: { fontSize: 14, fontFamily: 'Helvetica-Bold', color: DARK },

  noteBox: { padding: 10, backgroundColor: LIGHT, borderRadius: 6, marginBottom: 6 },
  noteText: { fontSize: 10, color: '#495057', lineHeight: 1.6 },

  salRow: { flexDirection: 'row', alignItems: 'center', marginBottom: 6 },
  salName: { width: '40%', fontSize: 10, color: DARK },
  salBarOuter: { flex: 1, height: 8, backgroundColor: '#e9ecef', borderRadius: 4, overflow: 'hidden', marginLeft: 8, marginRight: 8 },
  salBarInner: { height: '100%', borderRadius: 4 },
  salPercent: { width: 36, fontSize: 10, fontFamily: 'Helvetica-Bold', textAlign: 'right' },

  probRow: { flexDirection: 'row', alignItems: 'flex-start', marginBottom: 5, paddingBottom: 5, borderBottomWidth: 1, borderBottomColor: LIGHT, borderBottomStyle: 'solid' },
  probDot: { width: 8, height: 8, borderRadius: 2, marginRight: 8, marginTop: 2 },
  probText: { flex: 1, fontSize: 10, color: DARK },
  probPri: { fontSize: 8, color: GRAY, marginLeft: 6, width: 40 },

  matRow: { flexDirection: 'row', marginBottom: 4, paddingBottom: 4, borderBottomWidth: 1, borderBottomColor: LIGHT, borderBottomStyle: 'solid' },
  matDesc: { flex: 1, fontSize: 10, color: DARK },
  matQty: { fontSize: 10, color: GRAY, fontFamily: 'Helvetica-Bold', width: 80, textAlign: 'right' },

  // [FIX 5] Griglia foto
  photosGrid: { flexDirection: 'row', flexWrap: 'wrap', gap: 6, marginTop: 4 },
  photo: { width: '31.5%', height: 105, objectFit: 'cover', borderRadius: 4 },

  // [FIX 1] Footer — bottom 20→24, paddingTop 6→10
  footer: {
    position: 'absolute', bottom: 24, left: 40, right: 40,
    height: MARGIN_BOTTOM - 32,
    flexDirection: 'row', justifyContent: 'space-between', alignItems: 'flex-end',
    fontSize: 8, color: '#ccc',
    borderTopWidth: 1, borderTopColor: BORDER, borderTopStyle: 'solid',
    paddingTop: 10,
  },

  // [FIX 2] Separatore blocco scuro tra report
  daySeparator: {
    marginTop: 24, marginBottom: 12, padding: 12,
    backgroundColor: NAVY, borderRadius: 6,
  },
  daySepTitle: { fontSize: 12, fontFamily: 'Helvetica-Bold', color: '#fff' },
  daySepSub: { fontSize: 9, color: '#adb5bd', marginTop: 2 },

  // [FIX 3] Riepilogo finale
  summaryTitle: { fontSize: 14, fontFamily: 'Helvetica-Bold', color: DARK, marginBottom: 12, marginTop: 6 },
  summaryRow: { flexDirection: 'row', justifyContent: 'space-between', paddingTop: 4, paddingBottom: 4, borderBottomWidth: 1, borderBottomColor: LIGHT, borderBottomStyle: 'solid' },
});

function salColor(perc) {
  if (perc <= 30) return ORANGE;
  if (perc <= 70) return BLUE;
  return GREEN;
}

function probColor(pri) {
  if (pri === 'alta') return RED;
  if (pri === 'media') return ORANGE;
  return GREEN;
}

// -- Header fisso --
function PageHeader({ azienda, versione, cantiereTitolo }) {
  return (
    <View fixed style={s.fixedHeader}>
      <View style={s.headerBar} />
      <View style={s.logoRow}>
        <View style={s.logoInner}>
          <View style={s.logoBox}>
            <Text style={s.logoM}>m</Text>
          </View>
          <View>
            <Text style={s.logoName}>{azienda.nome || 'mAIstro'}</Text>
            {azienda.indirizzo ? <Text style={s.logoSub}>{azienda.indirizzo}</Text> : <Text style={s.logoSub}>ARTIGIANI</Text>}
          </View>
        </View>
        <View style={s.headerRight}>
          <Text style={s.headerRightText}>
            {versione === 'impresa' ? 'Versione Impresa' : 'Versione Cliente'}
          </Text>
          <Text style={{ ...s.headerRightText, color: '#ccc', marginTop: 1 }}>
            {cantiereTitolo}
          </Text>
        </View>
      </View>
      <View style={s.headerSep} />
    </View>
  );
}

// -- Sezione cantiere + cliente --
function CantiereSectionBlock({ cantiere }) {
  const indirizzoCompleto = [cantiere.indirizzo, cantiere.citta, cantiere.provincia].filter(Boolean).join(', ');
  return (
    <>
      <Text style={s.sectionTitle}>Cantiere</Text>
      <View style={s.infoGrid}>
        <View style={s.infoCell}>
          <Text style={s.infoLabel}>Cantiere</Text>
          <Text style={s.infoValue}>{cantiere.titolo}</Text>
        </View>
        {indirizzoCompleto ? (
          <View style={s.infoCell}>
            <Text style={s.infoLabel}>Indirizzo</Text>
            <Text style={s.infoValue}>{indirizzoCompleto}</Text>
          </View>
        ) : null}
        <View style={s.infoCell}>
          <Text style={s.infoLabel}>Tipologia</Text>
          <Text style={s.infoValue}>{TIPOLOGIA_LABEL[cantiere.tipologia] || cantiere.tipologia || '—'}</Text>
        </View>
        <View style={s.infoCell}>
          <Text style={s.infoLabel}>Stato cantiere</Text>
          <Text style={s.infoValue}>{STATO_LABEL[cantiere.stato] || cantiere.stato || '—'}</Text>
        </View>
        {cantiere.data_inizio ? (
          <View style={s.infoCell}>
            <Text style={s.infoLabel}>Data inizio</Text>
            <Text style={s.infoValue}>{fmtData(cantiere.data_inizio)}</Text>
          </View>
        ) : null}
        {cantiere.data_fine_stimata ? (
          <View style={s.infoCell}>
            <Text style={s.infoLabel}>Fine stimata</Text>
            <Text style={s.infoValue}>{fmtData(cantiere.data_fine_stimata)}</Text>
          </View>
        ) : null}
        {cantiere.valore_commessa ? (
          <View style={s.infoCell}>
            <Text style={s.infoLabel}>Valore commessa</Text>
            <Text style={s.infoValue}>{'\u20AC ' + Number(cantiere.valore_commessa).toLocaleString('it-IT')}</Text>
          </View>
        ) : null}
      </View>
      {cantiere.cliente_nome ? (
        <>
          <Text style={s.sectionTitle}>Cliente</Text>
          <View style={s.infoGrid}>
            <View style={s.infoCell}>
              <Text style={s.infoLabel}>Nome</Text>
              <Text style={s.infoValue}>{cantiere.cliente_nome}</Text>
            </View>
            {cantiere.cliente_indirizzo ? (
              <View style={s.infoCell}>
                <Text style={s.infoLabel}>Indirizzo</Text>
                <Text style={s.infoValue}>{cantiere.cliente_indirizzo}</Text>
              </View>
            ) : null}
            {cantiere.cliente_telefono ? (
              <View style={s.infoCell}>
                <Text style={s.infoLabel}>Telefono</Text>
                <Text style={s.infoValue}>{cantiere.cliente_telefono}</Text>
              </View>
            ) : null}
            {cantiere.cliente_email ? (
              <View style={s.infoCell}>
                <Text style={s.infoLabel}>Email</Text>
                <Text style={s.infoValue}>{cantiere.cliente_email}</Text>
              </View>
            ) : null}
            {cantiere.cliente_piva ? (
              <View style={s.infoCell}>
                <Text style={s.infoLabel}>P.IVA</Text>
                <Text style={s.infoValue}>{cantiere.cliente_piva}</Text>
              </View>
            ) : null}
          </View>
        </>
      ) : null}
    </>
  );
}

// [FIX 5] Sezione foto — filtra solo tipo=foto, max 20, nota troncamento
function PhotoSection({ media }) {
  if (!media || media.length === 0) return null;
  const foto = media.filter((m) => m.tipo === 'foto' && m.file_url);
  if (foto.length === 0) return null;
  const visibili = foto.slice(0, MAX_FOTO_PDF);
  const troncate = foto.length > MAX_FOTO_PDF;
  return (
    <>
      <Text style={s.sectionTitle}>Foto cantiere ({foto.length})</Text>
      <View style={s.photosGrid}>
        {visibili.map((f, i) => (
          <PDFImage key={f.id || i} src={f.file_url} style={s.photo} />
        ))}
      </View>
      {troncate ? (
        <Text style={{ fontSize: 8, color: GRAY, marginTop: 4, fontStyle: 'italic' }}>
          Mostrate le prime {MAX_FOTO_PDF} foto. Altre {foto.length - MAX_FOTO_PDF} disponibili sulla piattaforma.
        </Text>
      ) : null}
    </>
  );
}

// -- Corpo di un singolo report --
function ReportBody({ report, isImpresa }) {
  return (
    <>
      {/* KPI giornata */}
      <View style={s.kpiRow}>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Avanzamento</Text>
          <Text style={{ ...s.kpiValue, color: GREEN }}>{report.percentuale_avanzamento_globale}%</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Operai</Text>
          <Text style={s.kpiValue}>{report.numero_operai}</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Ore totali</Text>
          <Text style={s.kpiValue}>{report.ore_totali}h</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Meteo</Text>
          <Text style={s.kpiValue}>{METEO_LABEL[report.meteo] || '—'}</Text>
        </View>
      </View>
      <View style={{ marginTop: 6, marginBottom: 4 }}>
        <View style={{ height: 6, backgroundColor: '#e9ecef', borderRadius: 3, overflow: 'hidden' }}>
          <View style={{ width: report.percentuale_avanzamento_globale + '%', height: '100%', backgroundColor: GREEN, borderRadius: 3 }} />
        </View>
      </View>

      {report.attivita_svolte ? (
        <>
          <Text style={s.sectionTitle}>Attivita svolte</Text>
          <View style={s.noteBox}>
            <Text style={s.noteText}>{report.attivita_svolte}</Text>
          </View>
        </>
      ) : null}

      {report.sal_items && report.sal_items.length > 0 ? (
        <>
          <Text style={s.sectionTitle}>Stato avanzamento lavori (SAL)</Text>
          {report.sal_items.map((sal, i) => {
            const perc = parseInt(sal.percentuale) || 0;
            const color = salColor(perc);
            return (
              <View key={i} style={s.salRow}>
                <Text style={s.salName}>{sal.milestone_nome}</Text>
                <View style={s.salBarOuter}>
                  <View style={{ ...s.salBarInner, width: Math.max(perc, 2) + '%', backgroundColor: color }} />
                </View>
                <Text style={{ ...s.salPercent, color: color }}>{perc}%</Text>
              </View>
            );
          })}
        </>
      ) : null}

      {report.materiali && report.materiali.length > 0 ? (
        <>
          <Text style={s.sectionTitle}>Materiali utilizzati</Text>
          {report.materiali.map((m, i) => (
            <View key={i} style={s.matRow}>
              <Text style={s.matDesc}>{m.descrizione}</Text>
              <Text style={s.matQty}>{m.quantita} {m.unita}</Text>
            </View>
          ))}
        </>
      ) : null}

      {report.problemi && report.problemi.length > 0 ? (
        <>
          <Text style={s.sectionTitle}>Problemi / criticita</Text>
          {report.problemi.map((p, i) => {
            const color = probColor(p.priorita);
            return (
              <View key={i} style={s.probRow}>
                <View style={{ ...s.probDot, backgroundColor: color }} />
                <Text style={s.probText}>{p.descrizione}</Text>
                <Text style={{ ...s.probPri, color: color }}>
                  {p.priorita === 'alta' ? 'Alta' : p.priorita === 'media' ? 'Media' : 'Bassa'}
                </Text>
              </View>
            );
          })}
        </>
      ) : null}

      {/* [FIX 5] Foto — dopo problemi, prima delle note */}
      <PhotoSection media={report.media} />

      {isImpresa && report.note_per_domani ? (
        <>
          <Text style={s.sectionTitle}>Note per domani</Text>
          <View style={s.noteBox}>
            <Text style={s.noteText}>{report.note_per_domani}</Text>
          </View>
        </>
      ) : null}

      {isImpresa && report.note_interne ? (
        <>
          <Text style={s.sectionTitle}>Note interne</Text>
          <View style={{ ...s.noteBox, borderLeftWidth: 3, borderLeftColor: ORANGE, borderLeftStyle: 'solid' }}>
            <Text style={{ ...s.noteText, fontStyle: 'italic' }}>{report.note_interne}</Text>
          </View>
        </>
      ) : null}
    </>
  );
}

// [FIX 3] Riepilogo finale — aggregati di tutti i report
function RiepilogoFinale({ reports }) {
  const totaleOre = reports.reduce((sum, r) => sum + (r.ore_totali || 0), 0);
  const mediaOperai = reports.length > 0
    ? (reports.reduce((sum, r) => sum + (r.numero_operai || 0), 0) / reports.length).toFixed(1)
    : 0;
  const ultimoAvanzamento = reports.length > 0
    ? reports[reports.length - 1].percentuale_avanzamento_globale
    : 0;

  // Materiali aggregati
  const materialiMap = {};
  reports.forEach((r) => {
    (r.materiali || []).forEach((m) => {
      const key = m.descrizione + ' (' + m.unita + ')';
      materialiMap[key] = (materialiMap[key] || 0) + parseFloat(m.quantita || 0);
    });
  });
  const materialiList = Object.entries(materialiMap);

  // Problemi per gravita
  let alta = 0, media = 0, bassa = 0;
  reports.forEach((r) => {
    (r.problemi || []).forEach((p) => {
      if (p.priorita === 'alta') alta++;
      else if (p.priorita === 'media') media++;
      else bassa++;
    });
  });
  const totaleProblemi = alta + media + bassa;

  return (
    <>
      {/* Separatore visivo */}
      <View style={{ ...s.daySeparator, backgroundColor: GREEN, marginTop: 30 }}>
        <Text style={s.daySepTitle}>Riepilogo finale</Text>
        <Text style={s.daySepSub}>Aggregazione di tutti i {reports.length} report giornalieri</Text>
      </View>

      {/* KPI aggregati */}
      <View style={s.kpiRow}>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Ore totali</Text>
          <Text style={s.kpiValue}>{totaleOre}h</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Operai (media)</Text>
          <Text style={s.kpiValue}>{mediaOperai}</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Avanzamento</Text>
          <Text style={{ ...s.kpiValue, color: GREEN }}>{ultimoAvanzamento}%</Text>
        </View>
        <View style={s.kpiBox}>
          <Text style={s.kpiLabel}>Giornate</Text>
          <Text style={s.kpiValue}>{reports.length}</Text>
        </View>
      </View>

      {/* Materiali aggregati */}
      {materialiList.length > 0 ? (
        <>
          <Text style={s.sectionTitle}>Materiali totali utilizzati</Text>
          {materialiList.map(([nome, qty], i) => (
            <View key={i} style={s.summaryRow}>
              <Text style={{ fontSize: 10, color: DARK }}>{nome}</Text>
              <Text style={{ fontSize: 10, fontFamily: 'Helvetica-Bold', color: DARK }}>{qty}</Text>
            </View>
          ))}
        </>
      ) : null}

      {/* Problemi per gravita */}
      {totaleProblemi > 0 ? (
        <>
          <Text style={s.sectionTitle}>Problemi segnalati ({totaleProblemi})</Text>
          <View style={{ flexDirection: 'row', gap: 12 }}>
            {[
              { label: 'Alta', count: alta, color: RED },
              { label: 'Media', count: media, color: ORANGE },
              { label: 'Bassa', count: bassa, color: GREEN },
            ].filter((p) => p.count > 0).map((p) => (
              <View key={p.label} style={{ flexDirection: 'row', alignItems: 'center', gap: 4 }}>
                <View style={{ width: 8, height: 8, borderRadius: 2, backgroundColor: p.color }} />
                <Text style={{ fontSize: 10, color: DARK }}>{p.label}: {p.count}</Text>
              </View>
            ))}
          </View>
        </>
      ) : null}
    </>
  );
}

// ── PDF singolo report ──────────────────────────────────────────────────────
export default function ReportGiornalieroPDF({ report, cantiere, azienda, versione }) {
  const isImpresa = versione === 'impresa';
  const oggi = new Date().toLocaleDateString('it-IT');

  return (
    <Document>
      <Page size="A4" style={s.page}>
        <PageHeader azienda={azienda} versione={versione} cantiereTitolo={cantiere.titolo} />
        <View style={s.content}>
          <View style={s.titleSection}>
            <Text style={s.title}>Report Giornaliero — Giorno {report.giorno_numero}</Text>
            <Text style={s.subtitle}>
              {fmtData(report.data)}
              {report.meteo ? ' — ' + (METEO_LABEL[report.meteo] || report.meteo) : ''}
              {report.fase_corrente ? ' — Fase: ' + report.fase_corrente : ''}
            </Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <View style={{ backgroundColor: report.stato === 'confermato' ? GREEN : ORANGE, borderRadius: 4, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8 }}>
                <Text style={{ fontSize: 8, color: '#fff', fontFamily: 'Helvetica-Bold' }}>
                  {report.stato === 'confermato' ? 'Confermato' : 'Bozza'}
                </Text>
              </View>
              <Text style={{ fontSize: 8, color: GRAY }}>Generato il {oggi}</Text>
            </View>
          </View>
          <CantiereSectionBlock cantiere={cantiere} />
          <Text style={s.sectionTitle}>Riepilogo giornata</Text>
          <ReportBody report={report} isImpresa={isImpresa} />
        </View>
        <View style={s.footer} fixed>
          <Text>mAIstro — Gestionale per artigiani italiani</Text>
          <Text>{oggi}</Text>
          <Text render={({ pageNumber, totalPages }) => 'Pagina ' + pageNumber + ' di ' + totalPages} />
        </View>
      </Page>
    </Document>
  );
}

// ── PDF completo: tutti i report del cantiere ───────────────────────────────
export function ReportCompletoGiornalieroPDF({ reports, cantiere, azienda, versione }) {
  const isImpresa = versione === 'impresa';
  const oggi = new Date().toLocaleDateString('it-IT');
  const primo = reports[0];
  const ultimo = reports[reports.length - 1];
  const totaleOre = reports.reduce((sum, r) => sum + (r.ore_totali || 0), 0);
  const tot = reports.length;

  return (
    <Document>
      <Page size="A4" style={s.page}>
        <PageHeader azienda={azienda} versione={versione} cantiereTitolo={cantiere.titolo} />
        <View style={s.content}>

          {/* Copertina */}
          <View style={s.titleSection}>
            <Text style={s.title}>Report Completo Cantiere</Text>
            <Text style={s.subtitle}>
              {tot} report dal {fmtData(primo?.data)} al {fmtData(ultimo?.data)}
              {' — '}{totaleOre} ore totali
            </Text>
            <View style={{ flexDirection: 'row', alignItems: 'center', gap: 8 }}>
              <View style={{ backgroundColor: GREEN, borderRadius: 4, paddingTop: 2, paddingBottom: 2, paddingLeft: 8, paddingRight: 8 }}>
                <Text style={{ fontSize: 8, color: '#fff', fontFamily: 'Helvetica-Bold' }}>
                  {tot} report
                </Text>
              </View>
              <Text style={{ fontSize: 8, color: GRAY }}>Generato il {oggi}</Text>
            </View>
          </View>

          <CantiereSectionBlock cantiere={cantiere} />

          {/* [FIX 2] Ogni report con separatore blocco scuro */}
          {reports.map((report, idx) => (
            <View key={report.id || idx}>
              <View style={s.daySeparator}>
                <Text style={s.daySepTitle}>
                  Report {idx + 1} di {tot} — Giorno {report.giorno_numero} — {fmtData(report.data)}
                </Text>
                <Text style={s.daySepSub}>
                  {report.fase_corrente || ''}
                  {report.meteo ? ' — ' + (METEO_LABEL[report.meteo] || report.meteo) : ''}
                  {' — '}{report.numero_operai} operai, {report.ore_totali}h
                </Text>
              </View>
              <ReportBody report={report} isImpresa={isImpresa} />
            </View>
          ))}

          {/* [FIX 3] Riepilogo finale */}
          <RiepilogoFinale reports={reports} />

        </View>

        {/* [FIX 4] Footer con contesto cantiere */}
        <View style={s.footer} fixed>
          <Text>mAIstro — Gestionale per artigiani italiani</Text>
          <Text>{tot} report · {cantiere.titolo}</Text>
          <Text render={({ pageNumber, totalPages }) => 'Pagina ' + pageNumber + ' di ' + totalPages} />
        </View>
      </Page>
    </Document>
  );
}
